export const GETCATEGORY_REQUEST = 'GetCategoryReducer/GETCATEGORY_REQUEST';
export const GETCATEGORY_SUCCESS = 'GetCategoryReducer/GETCATEGORY_SUCCESS';
export const GETCATEGORY_FAILED = 'GetCategoryReducer/GETCATEGORY_FAILED';
export const GETLOCATION_REQUEST = 'GetLocationReducer/GETLOCATION_REQUEST';
export const GETLOCATION_SUCCESS = 'GetLocationReducer/GETLOCATION_SUCCESS';
export const GETLOCATION_FAILED = 'GetLocationReducer/GETLOCATION_FAILED';
export const GETTAG_REQUEST = 'GetTagReducer/GETTAG_REQUEST';
export const GETTAG_SUCCESS = 'GetTagReducer/GETTAG_SUCCESS';
export const GETTAG_FAILED = 'GetTagReducer/GETTAG_FAILED';